import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';
import { RequireToolAccess } from '../routing/RequireToolAccess';
import { Loading } from '../components/Loading';

// Loaded on demand: only a handful of directors ever open it, and the main
// bundle sits at workbox's precache cap (vite.config.ts).
const DirectorsStoreProvider = lazy(() => import('./store').then((m) => ({ default: m.DirectorsStoreProvider })));
const DirectorsSection = lazy(() => import('./DirectorsSection').then((m) => ({ default: m.DirectorsSection })));
const AgendaPage = lazy(() => import('./AgendaPage').then((m) => ({ default: m.AgendaPage })));
const ActionsPage = lazy(() => import('./ActionsPage').then((m) => ({ default: m.ActionsPage })));
const MeetingsPage = lazy(() => import('./MeetingsPage').then((m) => ({ default: m.MeetingsPage })));
const ArchivePage = lazy(() => import('./ArchivePage').then((m) => ({ default: m.ArchivePage })));
const CompanyMeetingPage = lazy(() => import('./CompanyMeetingPage').then((m) => ({ default: m.CompanyMeetingPage })));
const CloseMeetingPage = lazy(() => import('./CloseMeetingPage').then((m) => ({ default: m.CloseMeetingPage })));

/** One data load for every Directors' Room screen (tabs and Close meeting share it). */
function DirectorsRoot() {
  return (
    <RequireToolAccess slug="directors">
      <Suspense fallback={<div className="w-full max-w-page px-4 md:px-8 pt-6"><Loading /></div>}>
        <DirectorsStoreProvider>
          <Outlet />
        </DirectorsStoreProvider>
      </Suspense>
    </RequireToolAccess>
  );
}

/** Route tree, rendered inside App's <Routes>. Directors only (tools.directors.enabled). */
export const directorsRoutes = (
  <Route path="/directors" element={<DirectorsRoot />}>
    <Route element={<DirectorsSection />}>
      <Route index element={<AgendaPage />} />
      <Route path="actions" element={<ActionsPage />} />
      <Route path="meetings" element={<MeetingsPage />} />
      <Route path="archive" element={<ArchivePage />} />
      <Route path="company" element={<CompanyMeetingPage />} />
    </Route>
    <Route path="close/:date" element={<CloseMeetingPage />} />
  </Route>
);
